export const getFunnelStage = (variant) => {
    let funnelStage;

    if (variant === 'tripSummary') {
        funnelStage = 'trip_summary';
    } else if (variant === 'timeTable') {
        funnelStage = 'city_to_city';
    } else if (variant === 'travelOptions') {
        funnelStage = 'travel_options';
    } else {
        funnelStage = 'search';
    }

    return funnelStage;
};

export const getTotalDiscount = (fees, i18nMoney) => {
    if (!fees) {
        return undefined;
    }

    const userCurrency = i18nMoney.getCurrency();

    return fees.reduce((total, obj) => {
        let [currency, fee] = Object.entries(obj)[0];

        if (Object.prototype.hasOwnProperty.call(obj, userCurrency)) {
            currency = userCurrency;
            fee = obj[currency];
        }

        const discount = fee?.wanderu_discount_20;

        if (discount) {
            return total + i18nMoney.getConvertedPrice(discount, currency);
        }

        return total;
    }, 0);
};
